/**
 * Las piezas de las pantallas de entrada · 13-10-2026
 *
 * El saludo, las cifras que se pulsan y los accesos rápidos en tesela. Las usan
 * Inicio en el panel (`club/inicio/Inicio.tsx`) y Hoy en el back office
 * (`backoffice/Hoy.tsx`): dos pantallas para dos públicos, con la misma forma, para
 * que quien use las dos no tenga que aprender dos maneras de leer lo mismo.
 */
import { Icono, type NombreDeIcono } from '@/shared/ui/Icono';

function saludoDeLaHora(hora: number): string {
  if (hora < 6) return 'Buenas noches';
  if (hora < 14) return 'Buenos días';
  if (hora < 21) return 'Buenas tardes';
  return 'Buenas noches';
}

/** «Martes, 13 de octubre» y «Buenos días, Manuel». */
export function Saludo({
  nombre,
  children,
}: {
  nombre: string | null | undefined;
  /** Lo que va a la derecha del saludo: en el back office, el estado del servicio. */
  children?: React.ReactNode;
}) {
  const ahora = new Date();
  const dia = new Intl.DateTimeFormat('es-ES', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  }).format(ahora);
  const quien = nombre?.trim();

  return (
    <header className="inicio-saludo">
      <div>
        <p>{dia.charAt(0).toUpperCase() + dia.slice(1)}</p>
        <h1>
          {saludoDeLaHora(ahora.getHours())}
          {quien ? `, ${quien}` : ''}
        </h1>
      </div>
      {children}
    </header>
  );
}

export function Cifra({
  icono,
  valor,
  etiqueta,
  proporcion,
  alPulsar,
}: {
  icono: NombreDeIcono;
  valor: string;
  etiqueta: string;
  /** De 0 a 1: una barra debajo, para «cobrado de lo emitido» o «con la app». */
  proporcion?: number;
  alPulsar: () => void;
}) {
  return (
    <button type="button" className="cifra" onClick={alPulsar}>
      <span className="cifra-icono" aria-hidden="true">
        <Icono nombre={icono} tamano={20} />
      </span>
      <strong className="cifra-valor">{valor}</strong>
      <span className="cifra-etiqueta">{etiqueta}</span>
      {proporcion !== undefined && (
        <span className="cifra-barra" aria-hidden="true">
          <span
            style={{
              inlineSize: `${Math.round(Math.min(1, proporcion) * 100)}%`,
            }}
          />
        </span>
      )}
    </button>
  );
}

export function Acceso({
  icono,
  texto,
  alPulsar,
}: {
  icono: NombreDeIcono;
  texto: string;
  alPulsar: () => void;
}) {
  return (
    <button type="button" className="acceso-rapido" onClick={alPulsar}>
      <span className="acceso-rapido-icono" aria-hidden="true">
        <Icono nombre={icono} tamano={22} />
      </span>
      {texto}
    </button>
  );
}
